import { gql } from "@grandvisionhq/graphql";
const placeDetails = gql`
  fragment PlaceDetails on PlaceDetails {
    city
    country
    countryCode
    id
    postalCode
    province
    provinceShort
    streetName
    streetNumber
  }
`;
const GET_PLACE_DETAILS = gql`
  query GetPlaceDetailsById($id: String!) {
    placeDetailsById(id: $id) {
      ...PlaceDetails
    }
  }
  ${placeDetails}
`;
export {
  GET_PLACE_DETAILS
};
//# sourceMappingURL=get-place-details.js.map
